<template>
	<div>
		<v-col class="registrasi">
			<div class="d-flex justify-space-between">
				<div class="font-size-14 font-weight-bold secondary--text">Registrasi Mitra Ekonomis</div>
			</div>
			<template v-if="!loaderData">
				<div class="mt-5">
					<v-scroll-x-reverse-transition>
						<v-card class="pa-3 elevation-0 rounded-lg" outlined>
							<v-form ref="formRegistration" role="form">
								<!-- product section -->
								<v-row>
									<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3 px-md-4 pt-md-4">
										<v-card class="pa-4 pb-6 d-flex flex-column elevation-0 rounded-lg fill-height" outlined>
											<v-card-title class="pa-0 mb-4"><h5>Data Serial &amp; Jaringan</h5></v-card-title>
											<v-row>
												
												<v-col cols="12">
													<v-row>
														<v-col cols="12" sm="4" md="4" class="mb-2" v-if="false">
																<!-- item-text="serial_type_name" -->
															<v-select
																:items="['Ekonomi']"
																return-object
																no-data-text="Tidak Ada Tipe Serial"
																label="Tipe Serial"
																color="primary"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-barcode"
																outlined
																dense
																ref="serial_type"
																v-model="serial_type_text"
																tabindex="1"
																@change="selectSerialType"
															></v-select>
																<!-- :error-messages="(errorValidation !== undefined && errorValidation['serial_type'] !== undefined ) ? [errorValidation['serial_type']] : []"
																:rules="[rules.inputreq('Tipe Serial', params.serial_type)]" -->
														</v-col>

														<v-col cols="12" sm="4" md="4" class="mb-2">
															<template v-if="serialAvailList.length > 0">
																<v-select
																	:items="serialAvailList"
																	item-text="serial_id"
																	return-object
																	no-data-text="Tidak Ada Serial"
																	label="Serial"
																	color="primary"
																	class="input-regis"
																	hide-details="auto"
																	prepend-inner-icon="mdi-barcode"
																	outlined
																	dense
																	ref="serial"
																	v-model="serialSelected"
																	tabindex="2"
																	:error-messages="(errorValidation !== undefined && errorValidation['serial'] !== undefined ) ? [errorValidation['serial']] : []"
																	:rules="[rules.inputreq('Serial', params.serial)]"
																	@change="selectSerial"
																></v-select>
															</template>
															<template v-else>
																<v-text-field
																	label="Serial"
																	color="primary"
																	class="input-regis"
																	hide-details="auto"
																	prepend-inner-icon="mdi-barcode"
																	outlined
																	dense
																	ref="serial"
																	v-model="params.serial"
																	tabindex="2"
																	:error-messages="(errorValidation !== undefined && errorValidation['serial'] !== undefined ) ? [errorValidation['serial']] : []"
																	:rules="[rules.inputreq('Serial', params.serial)]"></v-text-field>
															</template>
														</v-col>

														<v-col cols="12" sm="4" md="4" class="mb-2">
															<v-text-field
																label="Pin Serial"
																color="primary"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-key"
																outlined
																dense
																ref="pin_serial"
																v-model="params.pin"
																tabindex="3"
																:type="typeInputSerial"
																:append-icon="iconSerial"
																@click:append="showSerialPin"
																:error-messages="(errorValidation !== undefined && errorValidation['pin'] !== undefined ) ? [errorValidation['pin']] : []"
																:rules="[rules.inputreq('Pin Serial', params.pin)]"></v-text-field>
														</v-col>
														<!-- <v-col cols="12" sm="4" md="4" class="mb-2"></v-col> -->

														<v-col cols="12" sm="4" md="4" class="mb-0">
															<v-text-field
																label="Kode Sponsor"
																color="primary"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-account"
																outlined
																dense
																ref="sponsor_network_code"
																v-model="params.sponsor_network_code"
																tabindex="4"
																:error-messages="(errorValidation !== undefined && errorValidation['sponsor_network_code'] !== undefined ) ? [errorValidation['sponsor_network_code']] : []"
																:rules="rules.sponsor_code"
																@change="getMitraSponsorName(params.sponsor_network_code, 'input')"></v-text-field>
																<div class="pt-1 font-size-9" :class="(sponsor_valid) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'">
																	{{ sponsor_name }}
																</div>
																<!-- <div class="grey--text" v-if="sponsorDataMember">{{sponsorDataMember.member_name}}</div> -->
														</v-col>
														<v-col cols="12" sm="4" md="4" class="mb-0">
															<v-text-field
																label="Kode Upline"
																color="primary"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-account"
																outlined
																dense
																ref="upline_network_code"
																v-model="params.upline_network_code"
																tabindex="5"
																:error-messages="(errorValidation !== undefined && errorValidation['upline_network_code'] !== undefined ) ? [errorValidation['upline_network_code']] : []"
																:rules="rules.upline_code"
																@change="uplineCheck"></v-text-field>
																<div class="pt-1 font-size-9" :class="(uplineDataMember) ? 'green--text text--darken-2 text-uppercase' : 'red--text text--darken-2'">
																	{{ (uplineDataMember) ? '[' + uplineDataMember.member_name + ']' : '' }}
																</div>
																<!-- <div class="grey--text" v-if="uplineDataMember">{{uplineDataMember.member_name}}</div> -->
														</v-col>
														<v-col cols="12" sm="4" md="4" class="d-flex flex-row justify-space-between align-start">
															<template v-if="isUplineExist">
																<div class="d-flex flex-row">
																	<v-icon large color="grey">mdi-account-network-outline</v-icon>
																	<div class="d-flex flex-row pl-3">
																		<small>Posisi jaringan</small>
																		<template v-if="params.position == 'L'"><h4 class="cl-primary">Kiri</h4></template>
																		<template v-else-if="params.position == 'R'"><h4 class="cl-primary">Kanan</h4></template>
																		<template v-else><span class="red--text font-size-10">Anda Belum Memilih Posisi</span></template>
																	</div>
																</div>
															</template>
															<template v-else>
																<!-- <v-card-subtitle class="py-0 px-0 font-weight-bold mt-2">Posisi jaringan</v-card-subtitle>
																<v-radio-group
																	v-model="params.position"
																	ref="position"
																	row
																	hide-details="auto"
																	class="mb-2 mt-1"
																	tabindex="4"
																	:disabled="($route.query.position !== undefined) ? true : false"
																	:rules="rules.position"
																	:error-messages="(errorValidation !== undefined && errorValidation['position'] !== undefined ) ? [errorValidation['position']] : []"
																>
																	<v-radio
																		label="Kiri"
																		value="L"
																		ref="positionL"
																	></v-radio>
																	<v-radio
																		label="Kanan"
																		value="R"
																		ref="positionR"
																	></v-radio>
																</v-radio-group> -->
																<v-autocomplete 
																	label="Pilih Posisi Jaringan" 
																	hide-details="auto" 
																	no-data-text="Tidak ada data" 
																	outlined
																	dense
																	color="primary" 
																	:items="listPosition" 
																	item-text="label" 
																	item-value="value" 
																	ref="position" 
																	v-model="params.position" 
																	:rules="[rules.inputreq('Posisi Jaringan', params.position)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['position'] !== undefined ) ? [errorValidation['position']] : []"
																	tabindex="6">
																	<!-- :disabled="($route.query.position !== undefined) ? true : false" -->
																	<template v-slot:selection="data">
																		<v-icon dense v-if="data.item.value === 'L'" style="-webkit-transform: scaleX(-1);transform: scaleX(-1);">mdi-account-arrow-right</v-icon>
																		<v-icon dense v-else>mdi-account-arrow-right-outline</v-icon>
																		<span class="cl-dark ml-3">{{ data.item.label }}</span>
																	</template>
																</v-autocomplete>
															</template>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-row>

								<!-- personal data section -->
								<v-row>
									<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3 px-md-4">
										<v-card outlined class="pa-4 d-flex flex-column elevation-0 rounded-lg fill-height">
											<v-card-title class="pa-0 mb-4"><h5>Data Akun Mitra</h5></v-card-title>
											<v-row>
												<v-col cols="12" sm="8" md="8">
													<v-card outlined class="pa-3 d-flex flex-column elevation-0 rounded-lg fill-height">
														<v-row>
															<v-col cols="12" sm="4" md="4">
																<v-autocomplete 
																	label="Jenis Kelamin"
																	placeholder="Pilih Jenis Kelamin"
																	hide-details="auto" 
																	no-data-text="Tidak ada data" 
																	outlined
																	dense
																	color="primary" 
																	item-color="primary"
																	:items="listGender" 
																	item-text="label" 
																	item-value="value" 
																	ref="gender" 
																	v-model="params.gender"
																	:rules="[rules.inputreq('Gender', params.gender)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['gender'] !== undefined ) ? [errorValidation['gender']] : []"
																	tabindex="7"></v-autocomplete>
															</v-col>
															<v-col cols="12" sm="8" md="8">
																<v-text-field
																	label="Nama Lengkap"
																	color="primary"
																	class="input-regis"
																	hide-details="auto"
																	prepend-inner-icon="mdi-account"
																	outlined
																	dense
																	ref="name"
																	v-model="params.name"
																	tabindex="8"
																	:error-messages="(errorValidation !== undefined && errorValidation['name'] !== undefined ) ? [errorValidation['name']] : []"
																	:rules="[rules.inputreq('Nama Mitra', params.name)]"></v-text-field>

																	<small class="text-caption">Nama Lengkap harus sesuai dengan nama yang tertera pada rekening bank Anda.</small>
																	<!-- @blur="params.bank_account_name = params.name" -->
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="12" sm="6" md="6">
																<v-text-field
																	label="Email"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-email"
																	hide-details="auto"
																	v-model="params.email"
																	tabindex="9"
																	outlined
																	dense
																	:error-messages="(errorValidation !== undefined && errorValidation['email'] !== undefined ) ? [errorValidation['email']] : []"
																	:rules="rules.email"></v-text-field>
															</v-col>
															<v-col cols="12" sm="6" md="6">
																<v-text-field
																	label="Nomor Handphone"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-cellphone"
																	v-model="params.mobilephone"
																	hide-details="auto"
																	maxlength="15"
																	:rules="rules.nohp"
																	outlined
																	dense
																	tabindex="10"
																	:error-messages="(errorValidation !== undefined && errorValidation['mobilephone'] !== undefined ) ? [errorValidation['mobilephone']] : []"
																	@keypress="onlyNumber"
																	@paste="validatePaste($event)"></v-text-field>
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="12" sm="6" md="6">
																<v-text-field 
																	label="Password"
																	color="primary"
																	class="input-regis"
																	v-model="params.password"
																	hide-details="auto"
																	:type="typeInput"
																	prepend-inner-icon="mdi-key-variant"
																	:append-icon="icon"
																	@click:append="showPassword"
																	outlined
																	dense
																	tabindex="11"
																	:error-messages="(errorValidation !== undefined && errorValidation['password'] !== undefined ) ? [errorValidation['password']] : []"
																	:rules="rules.password"></v-text-field>
															</v-col>
															<v-col cols="12" sm="6" md="6">
																<v-text-field 
																	label="Konfirmasi Password"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-key-variant"
																	v-model="params.password_confirm"
																	hide-details="auto"
																	:type="typeInputkonfirm"
																	:append-icon="iconPass"
																	@click:append="showPasswordKonfirm"
																	outlined
																	dense
																	tabindex="12"
																	:error-messages="(errorValidation !== undefined && errorValidation['password_confirm'] !== undefined ) ? [errorValidation['password_confirm']] : []"
																	:rules="rules.password_confirm"></v-text-field>
															</v-col>
														</v-row>
														<v-row>
															<v-col cols="12" sm="6" md="6">
																<v-text-field
																	label="Tempat Lahir"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-map-marker-right-outline"
																	hide-details="auto"
																	v-model="params.birth_place"
																	tabindex="13"
																	outlined
																	dense
																	:error-messages="(errorValidation !== undefined && errorValidation['birth_place'] !== undefined ) ? [errorValidation['birth_place']] : []"
																	:rules="[rules.inputreq('Tempat Lahir', params.birth_place)]"></v-text-field>
															</v-col>
															<v-col cols="12" sm="6" md="6">
																<v-menu 
																	v-model="birthDate"
																	:close-on-content-click="false"
																	:nudge-right="0"
																	transition="scale-transition"
																	offset-y min-width="290px">
																	<template v-slot:activator="{ on, attrs }">
																		<v-text-field
																			label="Tanggal Lahir"
																			color="primary"
																			class="input-regis"
																			prepend-inner-icon="mdi-calendar"
																			readonly
																			v-bind="attrs"
																			v-on="on"
																			outlined
																			dense
																			hide-details="auto"
																			tabindex="14"
																			:error-messages="(errorValidation !== undefined && errorValidation['birth_date'] !== undefined ) ? [errorValidation['birth_date']] : []"
																			:value="convertDate(params.birth_date)"
																			:rules="[rules.inputreq('Tanggal Lahir', params.birth_date)]"></v-text-field>
																	</template>
																	<v-date-picker locale="id" first-day-of-week="0" color="primary" :max="today" @input="birthDate = false" hide-details="auto" v-model="params.birth_date"></v-date-picker>
																</v-menu>
															</v-col>
														</v-row>

														<v-row>
															<v-col cols="12" sm="4" md="4">
																<v-autocomplete
																	label="Pilih Jenis Identitas" 
																	hide-details="auto" 
																	no-data-text="Tidak ada data" 
																	outlined
																	dense
																	color="primary" 
																	item-color="primary"
																	:items="['KTP']"
																	ref="identity_type" 
																	v-model="params.identity_type"
																	:rules="[rules.inputreq('Jenis Identitas', params.identity_type)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['identity_type'] !== undefined ) ? [errorValidation['identity_type']] : []"
																	tabindex="15"
																	@change="params.identity_no = ''"></v-autocomplete>
															</v-col>
															
															<v-col cols="12" sm="8" md="8">
																<!-- maxlength="16" @keypress="onlyNumber" -->
																<v-text-field
																	v-if="params.identity_type == 'PASPOR' || params.identity_type == ''"
																	label="Nomor Identitas"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-card-account-details"
																	hide-details="auto"
																	v-model="params.identity_no"
																	ref="identityNo"
																	outlined
																	dense
																	tabindex="16"
																	:rules="rules.noktp"
																	:error-messages="(errorValidation !== undefined && errorValidation['identity_no'] !== undefined ) ? [errorValidation['identity_no']] : []"
																	@paste="validatePaste($event, 'ktp')"
																	></v-text-field>
																<v-text-field
																	v-else
																	label="Nomor Identitas"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-card-account-details"
																	hide-details="auto"
																	v-model="params.identity_no"
																	ref="identityNo"
																	outlined
																	dense
																	tabindex="17"
																	:rules="rules.noktp"
																	:error-messages="(errorValidation !== undefined && errorValidation['identity_no'] !== undefined ) ? [errorValidation['identity_no']] : []"
																	@paste="validatePaste($event, 'ktp')"
																	@keypress="onlyNumber"
																	></v-text-field>
															</v-col>
														</v-row>
													</v-card>
												</v-col>

												<v-col cols="12" sm="4" md="4">
													<v-card outlined class="pa-3 d-flex flex-column elevation-0 rounded-lg fill-height">
														<v-row class="d-flex align-center">
															<v-col cols="12" class="d-none">
																<v-file-input
																	id="uploadIdentity"
																	hide-input
																	accept="image/png,image/jpeg,image/jpg,image/x-png"
																	prepend-icon="mdi-camera"
																	label="Pilih gambar"
																	v-model="identity_image_upload"
																	:rules="(identity_image_upload) ? rules.fileidentity : []"
																	@change="previewImageIdentity($event)"></v-file-input>
															</v-col>
															<v-col cols="12" class="d-flex align-center justify-space-between flex-column">
																<div style="display: block; position: relative; min-width: 160px; width: auto; max-width: 100%; margin: 0 auto;">
																	<v-img max-width="100%" width="auto" height="180px" class="rounded-lg d-block mx-auto" :src="(identity_image_url) ? identity_image_url : 'assets/image/no-image.png'" style="border: 1px solid #ddd;"></v-img>
																	<v-btn
																		elevation="3"
																		fab
																		icon
																		outlined
																		raised
																		rounded
																		small
																		class="btn-zoom"
																		@click="dialogZoomOpen(identity_image_url)"
																		v-if="identity_image_upload"
																	><v-icon color="#fff">mdi-magnify-plus-outline</v-icon></v-btn>
																	<v-btn
																		elevation="3"
																		color="error"
																		fab
																		icon
																		outlined
																		raised
																		rounded
																		x-small
																		style="position: absolute; top: -10px; right: -10px;background: #fff;"
																		@click="clearIdentityImg"
																		v-if="identity_image_upload"
																	><v-icon>mdi-close</v-icon></v-btn>
																</div>

																<v-btn
																	depressed
																	block
																	outlined
																	height="40px"
																	:color="(!identity_image_upload) ? (errorValidation['identity_image'] && errorValidation['identity_image'] !== undefined) ? 'red' :'primary' : '#408285'"
																	class="text-capitalize mt-4"
																	tabindex="18"
																	:loading="btn_loading"
																	:disabled="(identity_image_upload) ? true : false"
																	@click="openIdentityUpload">
																	<v-icon>mdi-file-upload-outline</v-icon>
																	<span class="pr-2 ms-2">Upload {{ params.identity_type }}</span>
																</v-btn>

																<small class="red--text mt-1" v-if="(errorValidation !== undefined && errorValidation['identity_image'] !== undefined) || !identity_image_upload">
																	{{ (errorValidation !== undefined && errorValidation['identity_image'] !== undefined) ? errorValidation['identity_image'] : (!identity_image_upload) ? '' : '' }}
																</small>
															</v-col>
															
														</v-row>
													</v-card>
												</v-col>
											</v-row>

											<v-row>
												<v-col cols="12" sm="4" md="4">
													<v-card outlined class="pa-3 d-flex flex-column elevation-0 rounded-lg fill-height">
														<v-checkbox
															v-model="isHasNpwp"
															class="ma-0"
															color="primary"
															style="margin-bottom: -15px!important;"
															tabindex="19"
															required
														>
															<template slot="label">
																<span class="d-none d-sm-flex align-center">
																	Inputkan Data NPWP Saya
																</span>

																<span class="d-flex d-sm-none flex-column">
																	<span class="d-flex flex-wrap">Inputkan Data NPWP Saya</span>
																</span>
															</template>
														</v-checkbox>

														<v-row class="mt-0 mb-2">
															<v-col cols="12" sm="12" md="12">
																<v-text-field
																	label="Nomor NPWP"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-card-account-details"
																	hide-details="auto"
																	v-model="params.npwp"
																	tabindex="20"
																	outlined
																	dense
																	@keypress="onlyNumber"
																	@paste="validatePaste($event)"
																	:disabled="(isHasNpwp) ? false : true"
																	></v-text-field>
																	<!-- :error-messages="(errorValidation !== undefined && errorValidation['npwp'] !== undefined ) ? [errorValidation['npwp']] : []"
																	:rules="(isHasNpwp) ? [rules.inputreq('Nomor NPWP', params.npwp)] : []" -->
															</v-col>
														</v-row>

														<v-checkbox
															v-model="isHasKK"
															class="ma-0"
															color="primary"
															style="margin-bottom: -15px!important;"
															tabindex="21"
															required
														>
															<template slot="label">
																<span class="d-none d-sm-flex align-center">
																	Inputkan Data Kartu Keluarga Saya
																</span>

																<span class="d-flex d-sm-none flex-column">
																	<span class="d-flex flex-wrap">Inputkan Data Kartu Keluarga Saya</span>
																</span>
															</template>
														</v-checkbox>

														<v-row class="mt-0">
															<v-col cols="12" sm="12" md="12">
																<v-text-field
																	label="Nomor KK"
																	color="primary"
																	class="input-regis"
																	prepend-inner-icon="mdi-card-account-details"
																	hide-details="auto"
																	v-model="params.kk_no"
																	tabindex="22"
																	outlined
																	dense
																	@keypress="onlyNumber"
																	@paste="validatePaste($event)"
																	:disabled="(isHasKK) ? false : true"
																	></v-text-field>
																	<!-- :error-messages="(errorValidation !== undefined && errorValidation['kk_no'] !== undefined ) ? [errorValidation['kk_no']] : []"
																	:rules="(isHasKK) ? [rules.inputreq('Nomor KK', params.kk_no)] : []" -->
															</v-col>
														</v-row>
													</v-card>
												</v-col>

												<v-col cols="12" sm="4" md="4">
													<v-card outlined class="pa-3 d-flex flex-column elevation-0 rounded-lg fill-height">
														<v-row class="d-flex align-center">
															<v-col cols="12" class="d-none">
																<v-file-input
																	id="uploadNpwp"
																	hide-input
																	accept="image/png,image/jpeg,image/jpg,image/x-png"
																	prepend-icon="mdi-camera"
																	label="Pilih gambar"
																	v-model="npwp_image_upload"
																	:rules="(npwp_image_upload) ? rules.filenpwp : []"
																	@change="previewImageNpwp($event)"></v-file-input>
															</v-col>
															<v-col cols="12" class="d-flex align-center justify-space-between flex-column">
																<div style="display: block; position: relative; min-width: 160px; width: auto; max-width: 100%; margin: 0 auto;">
																	<v-img max-width="100%" width="auto" height="180px" class="rounded-lg d-block mx-auto" :src="(npwp_image_url) ? npwp_image_url : 'assets/image/no-image.png'" style="border: 1px solid #ddd;"></v-img>
																	<v-btn
																		elevation="3"
																		fab
																		icon
																		outlined
																		raised
																		rounded
																		small
																		class="btn-zoom"
																		@click="dialogZoomOpen(npwp_image_url)"
																		v-if="npwp_image_upload"
																	><v-icon color="#fff">mdi-magnify-plus-outline</v-icon></v-btn>
																	<v-btn
																		elevation="3"
																		color="error"
																		fab
																		icon
																		outlined
																		raised
																		rounded
																		x-small
																		style="position: absolute; top: -10px; right: -10px;background: #fff;"
																		@click="clearNpwpImg"
																		v-if="npwp_image_upload"
																	><v-icon>mdi-close</v-icon></v-btn>
																</div>
															</v-col>

															<v-col cols="12" sm="12" md="12">
																<v-btn
																	depressed
																	block
																	outlined
																	height="40px"
																	:color="(!npwp_image_upload) ? (errorValidation['npwp_image'] && errorValidation['npwp_image'] !== undefined) ? 'red': 'primary' : '#408285'"
																	class="text-capitalize"
																	tabindex="23"
																	:loading="btn_loading"
																	:disabled="(npwp_image_upload || !isHasNpwp) ? true : false"
																	@click="openNpwpUpload">
																	<v-icon>mdi-file-upload-outline</v-icon>
																	<span class="pr-2 ms-2">Upload Foto NPWP</span>
																</v-btn>

																<small class="red--text mt-1" v-if="(errorValidation !== undefined && errorValidation['npwp_image'] !== undefined) || !npwp_image_upload">
																	{{ (errorValidation !== undefined && errorValidation['npwp_image'] !== undefined) ? errorValidation['npwp_image'] : (!npwp_image_upload) ? '' : '' }}
																</small>
															</v-col>
														</v-row>
													</v-card>
												</v-col>

												<v-col cols="12" sm="4" md="4">
													<v-card outlined class="pa-3 d-flex flex-column elevation-0 rounded-lg fill-height">
														<v-row class="d-flex align-center">
															<v-col cols="12" class="d-none">
																<v-file-input
																	id="uploadKK"
																	hide-input
																	accept="image/png,image/jpeg,image/jpg,image/x-png"
																	prepend-icon="mdi-camera"
																	label="Pilih gambar"
																	v-model="kk_image_upload"
																	:rules="(kk_image_upload) ? rules.filekk : []"
																	@change="previewImageKk($event)"></v-file-input>
															</v-col>

															<v-col cols="12" class="d-flex align-center justify-space-between flex-column">
																<div style="display: block; position: relative; min-width: 160px; width: auto; max-width: 100%; margin: 0 auto;">
																	<v-img max-width="100%" width="auto" height="180px" class="rounded-lg d-block mx-auto" :src="(kk_image_url) ? kk_image_url : 'assets/image/no-image.png'" style="border: 1px solid #ddd;"></v-img>
																	<v-btn
																		elevation="3"
																		fab
																		icon
																		outlined
																		raised
																		rounded
																		small
																		class="btn-zoom"
																		@click="dialogZoomOpen(kk_image_url)"
																		v-if="kk_image_upload"
																	><v-icon color="#fff">mdi-magnify-plus-outline</v-icon></v-btn>
																	<v-btn
																		elevation="3"
																		color="error"
																		fab
																		icon
																		outlined
																		raised
																		rounded
																		x-small
																		style="position: absolute; top: -10px; right: -10px;background: #fff;"
																		@click="clearKkImg"
																		v-if="kk_image_upload"
																	><v-icon>mdi-close</v-icon></v-btn>
																</div>

																<v-btn
																	depressed
																	block
																	outlined
																	height="40px"
																	:color="(!kk_image_upload) ? (errorValidation['kk_image'] && errorValidation['kk_image'] !== undefined) ? 'red' : 'primary' : '#408285'"
																	class="text-capitalize mt-4"
																	tabindex="24"
																	:loading="btn_loading"
																	:disabled="(kk_image_upload || !isHasKK) ? true : false"
																	@click="openKkUpload">
																	<v-icon>mdi-file-upload-outline</v-icon>
																	<span class="pr-2 ms-2">Upload Foto Kartu Keluarga</span>
																</v-btn>

																<small class="red--text mt-1" v-if="(errorValidation !== undefined && errorValidation['kk_image'] !== undefined) || !kk_image_upload">
																	{{ (errorValidation !== undefined && errorValidation['kk_image'] !== undefined) ? errorValidation['kk_image'] : (!kk_image_upload) ? '' : '' }}
																</small>
															</v-col>
															
														</v-row>
													</v-card>
												</v-col>
											</v-row>
											
										</v-card>
									</v-col>

									<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3 px-md-4">
										<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
											<v-card-title class="pa-0 mb-4"><h5>Alamat Mitra</h5></v-card-title>

											<v-row>
												<v-col cols="12" sm="8" md="8">
													<v-textarea
														name="alamat"
														label="Alamat"
														color="primary"
														v-model="params.address"
														hide-details="auto"
														prepend-inner-icon="mdi-map-marker-radius-outline"
														counter="255"
														maxlenght="255"
														rows="6"
														outlined
														dense
														tabindex="25"
													></v-textarea>
													<!-- :rules="[rules.inputreq('Alamat', params.address)]"
													:error-messages="(errorValidation !== undefined && errorValidation['address'] !== undefined ) ? [errorValidation['address']] : []" -->
												</v-col>

												<v-col cols="12" sm="4" md="4">
													<v-autocomplete
														label="Provinsi"
														no-data-text="Tidak ada data"
														color="primary"
														item-color="primary"
														hide-details="auto"
														prepend-inner-icon="mdi-map-marker-right-outline"
														:items="provinces"
														item-text="province_name"
														item-value="province_id"
														v-model="params.province_id"
														tabindex="24"
														outlined
														dense
														class="mb-5"
														@change="changeProvince"></v-autocomplete>
														<!-- :rules="[rules.inputreq('Pilihan Provinsi', params.province_id)]"
														:error-messages="(errorValidation !== undefined && errorValidation['province_id'] !== undefined ) ? [errorValidation['province_id']] : []" -->

														<v-autocomplete
															label="Kabupaten / Kota"
															no-data-text="Pilih Provinsi Dahulu"
															color="primary"
															item-color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="cities"
															item-text="city_name"
															item-value="city_id"
															v-model="params.city_id"
															outlined
															dense
															tabindex="27"
															class="mb-5"
															@change="changeCity"></v-autocomplete>
															<!-- :rules="[rules.inputreq('Pilihan Kota/kabupaten', params.city_id)]"
															:error-messages="(errorValidation !== undefined && errorValidation['city_id'] !== undefined ) ? [errorValidation['city_id']] : []" -->

														<v-autocomplete
															label="Kecamatan"
															no-data-text="Pilih Kabupaten / Kota Dahulu"
															color="primary"
															item-color="primary"
															hide-details="auto"
															prepend-inner-icon="mdi-map-marker-right-outline"
															:items="subdistricts"
															item-text="subdistrict_name"
															item-value="subdistrict_id"
															v-model="params.subdistrict_id"
															tabindex="28"
															outlined
															dense></v-autocomplete>
															<!-- :rules="[rules.inputreq('Pilihan Kecamatan', params.subdistrict_id)]"
															:error-messages="(errorValidation !== undefined && errorValidation['subdistrict_id'] !== undefined ) ? [errorValidation['subdistrict_id']] : []" -->
												</v-col>
											</v-row>
										</v-card>
									</v-col>

								</v-row>
								<!-- bank info section -->
								<v-row>
									<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3 px-md-4">
										<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
											<v-card-title class="pa-0 mb-4"><h5>Data Rekening Mitra</h5></v-card-title>
											<v-row>
												<v-col cols="12" sm="4" md="4">
													<v-autocomplete
														label="Nama Bank"
														hide-details="auto"
														no-data-text="Tidak ada data"
														color="primary"
														item-color="primary"
														prepend-inner-icon="mdi-bank-outline"
														:items="banks"
														item-text="bank_name"
														item-value="bank_id"
														v-model="params.bank_id"
														tabindex="29"
														return-object
														outlined
														dense
														:error-messages="(errorValidation !== undefined && errorValidation['bank_id'] !== undefined ) ? [errorValidation['bank_id']] : []" 
														@change="selectBank()"></v-autocomplete>
														<!-- :rules="[rules.inputreq('Nama Bank', params.bank_id)]" -->
												</v-col>
												<v-col cols="12" sm="4" md="4">
													<v-text-field
														ref="accountNo"
														label="Nomor Rekening"
														color="primary"
														hide-details="auto"
														prepend-inner-icon="mdi-account-box-outline"
														v-model="params.bank_account_no"
														tabindex="30"
														outlined
														dense
														:error-messages="(errorValidation !== undefined && errorValidation['bank_account_no'] !== undefined ) ? [errorValidation['bank_account_no']] : []"
														@keypress="onlyNumber"></v-text-field>
														<!-- :rules="[rules.inputreq('Nomor Rekening', params.bank_account_no)]"  -->
												</v-col>
												<v-col cols="12" sm="4" md="4">
													<v-text-field
														label="Nama Akun Rekening"
														color="primary"
														hide-details="auto"
														ref="bank_account_name"
														prepend-inner-icon="mdi-account"
														v-model="params.bank_account_name"
														outlined
														dense
														:error-messages="(errorValidation !== undefined && errorValidation['bank_account_name'] !== undefined ) ? [errorValidation['bank_account_name']] : []"
														tabindex="31"></v-text-field>
														<!-- :rules="[rules.inputreq('Nama Akun Rekening', params.bank_account_name)]" -->
												</v-col>
											</v-row>
										</v-card>
									</v-col>
									
									<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3 px-md-4">
										<v-card class="py-3 px-4 elevation-0 rounded-lg" outlined>
											<v-checkbox
												v-model="isAgreed"
												class="ma-0"
												color="primary"
												style="margin-bottom: -15px!important;"
												tabindex="32"
												required
											>
												<template slot="label">
													<span class="d-none d-sm-flex align-center">
														Saya telah membaca dan menyetujui 
														<v-btn x-small text color="primary" @click="showTerms()" class="font-weight-bold py-0 mt-1 px-1 ml-1">
															syarat &amp; ketentuan yang berlaku.
														</v-btn>
													</span>

													<span class="d-flex d-sm-none flex-column">
														<span class="d-flex flex-wrap">Saya telah membaca dan menyetujui</span>
														<v-btn x-small text color="primary" @click="showTerms()" class="d-flex flex-wrap justify-start text-left font-weight-bold py-0 px-0 mt-1">
															syarat &amp; ketentuan<br>yang berlaku.
														</v-btn>
													</span>
												</template>
											</v-checkbox>
										</v-card>
									</v-col>
								</v-row>

								<v-row justify="center" class="ml-0">
									<v-col cols="6" sm="3" md="2" class="pl-0">
										<v-btn large depressed block color="grey" class="white--text rounded-xl" :loading="btnLoadingProses" @click="goBack">
											<v-icon>mdi-arrow-left</v-icon>
											<span class="pl-2">Batal</span>
										</v-btn>
									</v-col>
									<v-col cols="6" sm="3" md="2" class="pl-0">
										<v-btn large depressed block color="primary" class="white--text rounded-xl" :loading="btnLoadingProses" :disabled="(isAgreed) ? false : true" tabindex="33" @click="processInput">
											<v-icon>mdi-content-save-outline</v-icon>
											<span class="pl-2">Simpan</span>
										</v-btn>
									</v-col>
								</v-row>
							</v-form>
						</v-card>
					</v-scroll-x-reverse-transition>
				</div>
			</template>

			<template v-else>
				<div class="mt-5">
					<LoadData :loading="loaderData"></LoadData>
				</div>
			</template>
		</v-col>

		<v-dialog
			v-model="dialogZoom"
			max-width="600"
		>
			<v-img width="600px" :src="(imgzoom) ? imgzoom : 'assets/image/no-image.png'" class="d-block mx-auto" style="border: 1px solid #ddd;"></v-img>
		</v-dialog>
		<ModalTerms ref="modalTerms" :terms="dataTerms"></ModalTerms>
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :type="typeRegis"></ModalSuccess>
		<!-- <ModalConfirm ref="modalConfirm" :msg="msgConfirm" :type="typeConfirm" @action="processToClone"></ModalConfirm> -->
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import ModalTerms from './components/ModalTerms'
import ModalSuccess from './components/ModalSuccess'
// import ModalConfirm from './components/ModalConfirm'

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default {
	components: {
		ModalSuccess,
		ModalTerms
	},
	data() {
		return {
			loaderData: false,
			loading: false,
			dialogZoom: false,
			imgzoom: '',
			btn_loading: false,
			btn_disabled: false,
			btnLoadingProses: false,
			companies: (process.env.VUE_APP_CLIENT_NAME !== undefined) ? process.env.VUE_APP_CLIENT_NAME : '',
			typeInput: 'password',
			typeInputkonfirm: 'password',
			typeInputSerial: 'password',
			icon: 'mdi-eye',
			iconSerial: 'mdi-eye',
			iconPass: 'mdi-eye',
			page: 1,
			limit: '100',
			suksesInput: false,
			isUplineExist: false,
			selectedProduct: null,
			selectedBanktf: null,
			birthDate: '',
			identity_image_upload: null,
			identity_image_url: '',
			npwp_image_upload: null,
			npwp_image_url: '',
			kk_image_upload: null,
			kk_image_url: '',
			tempRegister: null,
			dataTerms: null,
			isAgreed: false,
			isHasNpwp: false,
			isHasKK: false,
			uplineDataMember: {},
			sponsor_name: '',
			sponsor_valid: true,
			serial_type_text: 'Ekonomi',
			serialSelected: null,
			params: {
				sponsor_network_code: '',
				upline_network_code: '',
				serial_type: 3,
				serial: '',
				pin: '',
				name: '',
				email: '',
				identity_type: '',
				identity_no: '',
				npwp: '',
				mobilephone: '',
				gender: '',
				birth_place: '',
				birth_date: null,
				address: '',
				subdistrict_id: '',
				city_id: '',
				province_id: '',
				country_id: '102',
				bank_id: '',
				bank_name: '',
				bank_account_name: '',
				bank_account_no: '',
				bank_province_id: '',
				bank_city: '',
				bank_branch: '',
				identity_image: null,
				npwp_image: null,
				kk_image: null,
				kk_no: '',
				position: '',
				password: '',
				password_confirm: ''
			},
			listPosition: [
				{
					label: 'Kanan',
					value: 'R'
				},
				{
					label: 'Kiri',
					value: 'L'
				}
			],
			listGender: [
				{
					label: 'Laki-laki',
					value: 'Laki-laki'
				},
				{
					label: 'Perempuan',
					value: 'Perempuan'
				}
			],
			listShippingMethod: [
				{
					label: 'Pick Up',
					value: 'pick up'
				},
				{
					label: 'Kurir',
					value: 'courier'
				}
			],
			rules: {
				filenpwp: [
					// v => !!v || 'File bukti transfer pembayaran tidak boleh kosong',
					v => (v && v.size < 3000000) || 'Ukuran foto npwp tidak boleh lebih dari 3 MB',
				],
				fileidentity: [
					// v => !!v || 'File scan/foto identitas tidak boleh kosong',
					// v => (v && v.size > 0) || 'File scan/foto identitas tidak boleh kosong',
					v => (v && v.size < 3000000) || 'Ukuran foto identitas tidak boleh lebih dari 3 MB',
				],
				fileKk: [
					// v => !!v || 'File scan/foto kartu keluarga tidak boleh kosong',
					// v => (v && v.size > 0) || 'File scan/foto kartu keluarga tidak boleh kosong',
					v => (v && v.size < 3000000) || 'Ukuran foto kartu keluarga tidak boleh lebih dari 3 MB',
				],
				input: [
					v => !!v || 'Tidak boleh kosong'
				],
				inputreq(label, v) { 
					return !!v || label + ' tidak boleh kosong'
				},
				sponsor_code: [
					v => !!v || 'Kode Sponsor tidak boleh kosong',
					// v => ( v && this.sponsor_valid ) || "Data mitra tidak ditemukan",
				],
				upline_code: [
					v => !!v || 'Kode Upline tidak boleh kosong',
					// v => ( v && this.upline_valid ) || "Data mitra tidak ditemukan",
				],
				position: [
					v => !!v || 'Posisi Jaringan wajib dipilih',
				],
				email: [
					v => !!v || 'Email tidak boleh kosong',
					v => !!validateEmail(v) || 'Format Email tidak sesuai',
				],
				noktp: [
					v => !!v || 'Nomor Identitas tidak boleh kosong',
					// v => ( v && v.length >= 16 ) || "Nomor KTP tidak boleh kurang dari 16 angka",
					// v => ( v && v.length <= 16 ) || "Nomor KTP tidak boleh lebih dari 16 angka",
				],
				nohp: [
					v => !!v || 'Nomor Handphone tidak boleh kosong',
					v => ( v && v.length <= 16 ) || "Nomor Handphone tidak boleh lebih dari 16 angka",
					v => ( v && v.length > 6 ) || "Nomor Handphone tidak boleh kurang dari 6 angka",
				],
				password: [
					v => !!v || 'Tidak boleh kosong',
					v => ( v && v.length >= 6 ) || "Password tidak boleh kurang dari 6 karakter",
				],
				password_confirm: [
					v => !!v || 'Tidak boleh kosong',
					v => ( v && v.length >= 6 ) || "Password tidak boleh kurang dari 6 karakter",
					v => ( v && v == this.params.password ) || "Konfirmasi password harus sama dengan password",
				],
			},
			msgSuccess: '',
			msgFailed: '',
			typeRegis: ''
		}
	},
	watch: {
		$route (to, from){
      if(to !== from) this.reset()
    }
  },
	computed: {
		...mapState('autentikasi', ['userData']),
		...mapState('jaringan', ['memberData', 'errorValidation']),
		...mapState('serial', ['serialAvailList', 'serialElitePagination', 'serialStarPagination']),
		...mapState('opsi', ['provinces', 'cities', 'subdistricts', 'banks', 'uplineData']),
		// ...mapState(['errorValidation']),
	},
	methods: {
		...mapActions('jaringan', ['addRegistration', 'resetValidation']),
		...mapActions('opsi', ['getProvince', 'getCity', 'getSubdistrict', 'getBank', 'getUplineData', 'getMemberByCode']),
		...mapActions('serial', ['getSerialAvailList', 'getSerialEliteList', 'getSerialStarList']),
		...mapMutations(['emptyErrorValidation']),

		getDataStokSerial() {
			this.getSerialEliteList(this.queryString({limit:10, page: 1, sort: 'serial_is_used', dir: 'asc'}))
			this.getSerialStarList(this.queryString({limit:10, page: 1, sort: 'serial_is_used', dir: 'asc'}))
		},

		uplineCheck() {
			this.emptyErrorValidation()
			this.uplineDataMember = ''
			// this.params.sponsor_network_code = this.userData.member_network_code
			if (this.params.sponsor_network_code !== '') {
				this.getUplineData({sponsor_network_code: this.params.sponsor_network_code, upline_network_code: this.params.upline_network_code}).then(() => {
						this.uplineDataMember = this.uplineData
				})
			}
		},

		getMitraSponsorName(mitra_code, trigger) {
			if (mitra_code) {
				this.getMemberByCode({network_code: mitra_code})
				.then((response) => {
					if (Object.keys(response).length > 0) {
						if (trigger === 'input') {
							this.sponsor_name = '[' + response.member_name + ']'
							this.sponsor_valid = true

							setTimeout(() => {
								if (this.$refs.upline_network_code !== undefined) this.$refs.upline_network_code.focus()
							}, 200);
						}
					} else {
						this.sponsor_name = ''
						this.sponsor_valid = false
						setTimeout(() => {
							if (this.$refs.sponsor_network_code !== undefined)  this.$refs.sponsor_network_code.focus()
						}, 200);
					}

					this.uplineCheck()
					
				}).catch(() => {
					this.sponsor_name = 'Data mitra sponsor tidak ditemukan.'
					this.sponsor_valid = false
				})
			} else {
				this.sponsor_name = ''
				this.sponsor_valid = false
			}
		},

		async validatePaste(val, type){
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				if (!parseInt(pasted)) {
					if (type === 'ktp') {
						val.preventDefault()
					} else {
						val.preventDefault()
					}
				}
			})
		},

		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		showPasswordKonfirm() {
			this.typeInputkonfirm = this.typeInputkonfirm == 'text' ? 'password' : 'text'
			this.iconPass = this.iconPass == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		showSerialPin() {
			this.typeInputSerial = this.typeInputSerial == 'text' ? 'password' : 'text'
			this.iconSerial = this.iconSerial == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},


		goBack() {
			this.$router.push({name: 'genealogy-ekonomis'})
		},

		reset() {
			this.birthDate = null
			this.identity_image_upload = null
			this.npwp_image_upload = null
			this.kk_image_upload = null
			this.identity_image_url = ''
			this.npwp_image_url = ''
			this.kk_image_url = ''
			this.dataTerms = null
			this.isAgreed = false
			this.isHasNpwp = false
			this.isHasKK = false
			this.uplineDataMember = {}
			this.serial_type_text = 'Ekonomi'
			this.serialSelected = null
			this.params = {
				serial_type: 1,
				sponsor_network_code: '',
				upline_network_code: '',
				serial: '',
				pin: '',
				name: '',
				email: '',
				password: '',
				password_confirm: '',
				identity_type: '',
				identity_no: '',
				npwp: '',
				mobilephone: '',
				gender: '',
				birth_place: '',
				birth_date: null,
				address: '',
				subdistrict_id: '',
				city_id: '',
				province_id: '',
				country_id: '102',
				bank_id: '',
				bank_name: '',
				bank_account_name: '',
				bank_account_no: '',
				identity_image: '',
				kk_image: '',
				kk_no: '',
				position: ''
			}
			// this.params.sponsor_network_code = this.userData.member_network_code
			this.dialogZoom = false
			this.imgzoom = ''
		},

		openNpwpUpload() {
			document.getElementById('uploadNpwp').click()
		},

		openIdentityUpload() {
			document.getElementById('uploadIdentity').click()
		},
		
		openKkUpload() {
			document.getElementById('uploadKK').click()
		},

		clearNpwpImg() {
			this.npwp_image_upload = null
			this.npwp_image_url = ''
			this.errorValidation['npwp_image'] = null
		},

		clearIdentityImg() {
			this.identity_image_upload = null
			this.identity_image_url = ''
			this.errorValidation['identity_image'] = null
		},

		clearKkImg() {
			this.kk_image_upload = null
			this.kk_image_url = ''
			this.errorValidation['kk_image'] = null
		},

		changeProvince() {
			this.getCity({ province_id: this.params.province_id	})
			this.params.city_id = ''
			this.params.subdistrict_id = ''
		},

		changeCity() {
			this.getSubdistrict({ city_id: this.params.city_id	})
			this.params.subdistrict_id = ''
		},

		changeBankProvince() {
			this.getBankCity({ province_id: this.params.bank_province_id	})
			this.params.bank_city = ''
		},

		previewImageNpwp(event) {
			if (event) {
				if (event.size > 3000000) {
					this.errorValidation['npwp_image'] = 'Ukuran foto Npwp tidak boleh lebih dari 3 MB'
					this.npwp_image_upload = null
					this.btn_disabled = true
				} else {
					this.npwp_image_url = URL.createObjectURL(this.npwp_image_upload)
					this.btn_disabled = false
					this.errorValidation['npwp_image'] = null
				}
			} else {
				this.npwp_image_url = null
				this.btn_disabled = true
			}
		},

		previewImageIdentity(event) {
			if (event) {
				if (event.size > 3000000) {
					this.errorValidation['identity_image'] = 'Ukuran foto identitas tidak boleh lebih dari 3 MB'
					this.identity_image_upload = null
					this.btn_disabled = true
				} else {
					this.identity_image_url = URL.createObjectURL(this.identity_image_upload)
					this.btn_disabled = false
					this.errorValidation['identity_image'] = null
				}
			} else {
				this.identity_image_url = null
				this.btn_disabled = true
			}
		},

		previewImageKk(event) {
			if (event) {
				if (event.size > 3000000) {
					this.errorValidation['kk_image'] = 'Ukuran foto KK tidak boleh lebih dari 3 MB'
					this.kk_image_upload = null
					this.btn_disabled = true
				} else {
					this.kk_image_url = URL.createObjectURL(this.kk_image_upload)
					this.btn_disabled = false
					this.errorValidation['kk_image'] = null
				}
			} else {
				this.kk_image_url = null
				this.btn_disabled = true
			}
		},

		dialogZoomOpen(img) {
			this.imgzoom = img
			this.dialogZoom = true
		},

		getTermContent() {
			this.dataTerms = {
				title: 'Syarat & ketentuan',
				content: 'Belum ada konten yang tersedia.'
			}
		},

		showTerms() {
			this.getTermContent()
			this.$refs.modalTerms.modalShow()
		},

		getData() {
			// this.params.sponsor_network_code = this.userData.member_network_code
			this.getProvince()
			this.getBank()
			// this.getSerialAvailList()
		},

		async selectBank() {
			const selectedBank = await this.params.bank_id
			this.params.bank_id = selectedBank.bank_id
			this.params.bank_name = selectedBank.bank_name
		},

		async selectSerial() {
			if (this.serialSelected) {
				this.params.serial = this.serialSelected.serial_id
				this.params.pin = this.serialSelected.serial_pin
			} else {
				this.params.serial = ''
				this.params.pin = ''
			}
		},

		async selectSerialType() {
			if (this.serial_type_text !== '') { 
				this.params.serial_type = await 3

				this.getSerialAvailList({ type_id: this.params.serial_type })
				this.params.serial = ''
				this.params.pin = ''
			}
		},

		async addRegistrationMitra() {
			// this.params.sponsor_network_code = await this.userData.member_network_code
			this.params.npwp_image = await this.npwp_image_upload
			this.params.identity_image = await this.identity_image_upload
			this.params.kk_image = await this.kk_image_upload

			let formDataRegis = new FormData()
			formDataRegis.append('sponsor_network_code', this.params.sponsor_network_code)
			formDataRegis.append('upline_network_code', this.params.upline_network_code)
			formDataRegis.append('serial', this.params.serial)
			formDataRegis.append('pin', this.params.pin)
			formDataRegis.append('name', this.params.name)
			formDataRegis.append('email', this.params.email)
			formDataRegis.append('identity_type', this.params.identity_type)
			formDataRegis.append('identity_no', this.params.identity_no)
			formDataRegis.append('mobilephone', this.params.mobilephone)
			formDataRegis.append('gender', this.params.gender)
			formDataRegis.append('birth_place', this.params.birth_place)
			formDataRegis.append('birth_date', this.params.birth_date)
			formDataRegis.append('address', this.params.address)
			formDataRegis.append('subdistrict_id', this.params.subdistrict_id)
			formDataRegis.append('city_id', this.params.city_id)
			formDataRegis.append('province_id', this.params.province_id)
			formDataRegis.append('country_id', this.params.country_id)
			formDataRegis.append('bank_id', this.params.bank_id)
			formDataRegis.append('bank_name', this.params.bank_name)
			formDataRegis.append('bank_account_name', this.params.bank_account_name)
			formDataRegis.append('bank_account_no', this.params.bank_account_no)
			formDataRegis.append('npwp', (this.isHasNpwp) ? this.params.npwp : '')
			formDataRegis.append('npwp_image', (this.isHasNpwp) ? this.npwp_image_upload : '')
			formDataRegis.append('kk_image', (this.isHasKK) ? this.kk_image_upload : '')
			formDataRegis.append('kk_no', (this.isHasKK) ? this.params.kk_no : '')
			formDataRegis.append('identity_image', this.identity_image_upload)
			formDataRegis.append('position', this.params.position)
			formDataRegis.append('password', this.params.password)
			formDataRegis.append('password_confirm', this.params.password_confirm)

			// this.tempRegister = this.params
			// this.successRegistration(this.tempRegister, 'mitra')
			this.addRegistration(formDataRegis).then((response) => {
				this.emptyErrorValidation()
				this.tempRegister = this.params
				this.successRegistration(this.tempRegister, response.network_code, 'mitra')
				this.reset()
			}).catch(() => {
				// this.emptyErrorValidation()
				window.scrollTo(0,0)
				this.btnLoadingProses = false
			})
		},

		async processInput() {
			this.btnLoadingProses = await true
			if (this.$refs.formRegistration.validate()) {
				await this.addRegistrationMitra()
				setTimeout(() => {
					this.btnLoadingProses = false
				}, 1500);
			} else {
				window.scrollTo(0,0)
				this.btnLoadingProses = false
			}
		},

		successRegistration(data,network_code) {
			if(data) {
				this.msgSuccess = `
					<span class="d-block font-weight-bold cl-primary-dark font-size-12" style="width: 85%; margin: 0 auto;">Selamat!</span><br>
					<span class="d-block font-weight-bold cl-primary-dark font-size-12" style="width: 85%; margin: 0 auto;">Registrasi mitra Anda telah berhasil didaftarkan di sistem ${this.companies}</span><br>
					<div class="d-block text-center my-4 pa-4" style="border: 2px solid #263238; border-radius: 10px">
						<span class="d-block mb-2"><span style="display: inline-block;">Nama Mitra</span> :<br><strong class="primary--text">${data.name}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block;">Nomor Handphone</span> :<br><strong class="primary--text">${data.mobilephone}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block;">Kode Mitra</span> :<br><strong class="primary--text">${network_code}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block;">Kode Upline</span> :<br><strong class="primary--text">${data.upline_network_code}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block;">Posisi</span> :<br><strong class="primary--text">${data.position == "L" ? 'Kiri' : 'Kanan'}</strong></span>
					</div>
				`
				this.emptyErrorValidation()
				this.$refs.modalSuccess.modalShow()
			}
		},

			bulkRegister() {
			// this.params.sponsor_network_code = this.userData.member_network_code
			this.params.upline_network_code = 'KEX1000001'
			this.params.serial = 'A000000001'
			// this.params.username = 'member23'
			// this.params.password = '123456'
			this.params.name = 'Member Dummy'
			this.params.email = 'member@dummy.com'
			this.params.identity_type = 'KTP'
			this.params.identity_no = '1234567890123456'
			this.params.mobilephone = '08123456789'
			this.params.gender = 'Perempuan'
			this.params.birth_place = 'Yogyakarta'
			this.params.birth_date = '2000-12-31'
			this.params.address = 'Jl. Yogyakarta'
			this.params.subdistrict_id = '538'
			this.params.city_id = '39'
			this.params.province_id = '5'
			this.params.country_id = '102'
			this.params.bank_company_bank_id = '1'
			this.params.bank_name = 'Bank BCA'
			this.params.bank_account_name = 'member bank'
			this.params.bank_account_no = '1234123412341234'
			// this.params.bank_city = 'Yogyakarta'
			// this.params.bank_province_id = '5'
			// this.params.bank_branch = 'Katamso'
			// this.params.mother_name = 'mother'
			// this.params.devisor_name = 'devisor'
			// this.params.devisor_relation = 'son'
			// this.params.transfer_bank_name = 'Bank BCA'
			// this.params.transfer_bank_account_no = '1234123412341234'
			// this.params.package_name = 'Sahabat'
			// this.params.package_price = '1956000'
			// this.params.social_media = ''

			if (this.city && this.params.city_id) {
				this.getSubdistrict({ city_id: this.params.city_id	})
				setTimeout(() => {
					this.params.subdistrict_id = '538'
				}, 600)
			}
		}
	},

	async created() {
		this.loaderData = await true
		this.reset()
		this.params.upline_network_code = this.$route.query.upline
		this.params.position = this.$route.query.position
		if (this.$route.query.upline) {
			this.uplineCheck()
		}
		await this.emptyErrorValidation()
		// this.bulkRegister()
		await this.$store.dispatch('setPageTitle', 'Registrasi Mitra Ekonomis')
		await this.getData()
		this.getDataStokSerial()
		this.selectSerialType()

		setTimeout(() => { 
			this.loaderData = false
		}, 1000)
	}
};
</script>

<style lang="scss" scoped>
	.icon-upload-image {
		margin-top: -3.3rem !important;
		margin-left: 9.5rem !important;
	}

	.btn-zoom {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: rgba(0,0,0,0.4);

		&:hover, &:focus {
			background: rgba(0,0,0,0.6);
		}
	}
</style>